exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Player_timestretch_player_container__2r5F7 {\n  width: 100%;\n  height: 800px;\n}\n\n.Player_timestretch_player__3qWQt {\n  width: 100%;\n  height: 100%;\n}\n", "", {"version":3,"sources":["/Users/mr/Documents/Holzer/TimeStretch Player/timestretch-player/src/Player.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,cAAc;CACf;;AAED;EACE,YAAY;EACZ,aAAa;CACd","file":"Player.module.css","sourcesContent":[".timestretch_player_container {\n  width: 100%;\n  height: 800px;\n}\n\n.timestretch_player {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"timestretch_player_container": "Player_timestretch_player_container__2r5F7",
	"timestretch_player": "Player_timestretch_player__3qWQt"
};